import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, mixins } from "@similarweb/styles";
import styled from "styled-components";

export const StyledArrowIcon = styled(SWReactIcons)`
    margin-left: 8px;

    & svg path {
        fill: ${colorsPalettes.carbon["500"]};
    }
`;

export const StyledButtonText = styled.h2`
    ${mixins.setFontVariant("h4", colorsPalettes.carbon["500"])};
    ${mixins.truncateText()};
    line-height: 32px;
    margin: 0;
    max-width: 800px;
`;

export const StyledListIcon = styled(SWReactIcons)`
    margin-right: 8px;

    & svg > path {
        fill: ${colorsPalettes.carbon["500"]};
    }
`;

export const StyledDropdownButton = styled.div`
    align-items: center;
    cursor: pointer;
    display: flex;
`;
